import { Typography } from '@arionbanki/arionui';
import { Footer, Markdown, ProgressBar } from 'components';
import { NetbankForm } from './NetbankForm';
import { useNetbank } from './useNetbank';

export function Netbank() {
	const ctx = useNetbank();
	return (
		<ProgressBar page="netbank">
			<Typography className="mb-5" TagName="h3">
				{ctx.t('title', 'netbank')}
			</Typography>
			<Markdown>{ctx.t('main', 'netbank')}</Markdown>
			<hr className="my-4" />
			<NetbankForm {...ctx} />
			<Footer
				handleNext={ctx.submitForm}
				handlePrev={ctx.goBack}
				isDisabled={false}
				next={ctx.t('continue')}
				prev={ctx.t('back')}
			/>
		</ProgressBar>
	);
}
